var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo, useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchPublisherPrefixRanges } from "../api/publisherPrefixRange";
import { createStripesSource } from "../utils/createStripesSource";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
export var usePublisherPrefixRangeData = function (filters, pageSize) {
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    var ky = useOkapiKy();
    var _a = useState(0), pageOffset = _a[0], setPageOffset = _a[1];
    var _b = useState(0), totalRecords = _b[0], setTotalRecords = _b[1];
    var _c = useQuery(["publisher-prefix-ranges", filters, pageOffset, pageSize], function () {
        return fetchPublisherPrefixRanges(ky, __assign(__assign({}, filters), { offset: pageOffset, limit: pageSize }));
    }, {
        onSuccess: function (payload) { var _a; return setTotalRecords((_a = payload === null || payload === void 0 ? void 0 : payload.totalRecords) !== null && _a !== void 0 ? _a : 0); },
        keepPreviousData: true,
    }), data = _c.data, isLoading = _c.isLoading, isError = _c.isError, refetch = _c.refetch, isFetched = _c.isFetched;
    var items = useMemo(function () { var _a; return (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : []; }, [data === null || data === void 0 ? void 0 : data.items]);
    var fetchMoreData = useCallback(function (offset) {
        setPageOffset(offset);
    }, []);
    var resetPageOffset = useCallback(function () { return setPageOffset(0); }, []);
    var source = useMemo(function () {
        return createStripesSource({
            ky: ky,
            data: items,
            totalRecords: totalRecords,
            isLoading: isLoading,
            isError: isError,
            isLoaded: isFetched,
            fetchMore: function () { return fetchMoreData(pageOffset + pageSize); },
        });
    }, [
        ky,
        items,
        totalRecords,
        isLoading,
        isError,
        isFetched,
        fetchMoreData,
        pageOffset,
        pageSize,
    ]);
    return {
        items: items,
        totalRecords: totalRecords,
        isLoading: isLoading,
        isError: isError,
        isFetched: isFetched,
        pageOffset: pageOffset,
        refetch: refetch,
        fetchMoreData: fetchMoreData,
        resetPageOffset: resetPageOffset,
        source: source,
        pageSize: pageSize,
    };
};
